<!-- Modal (Gerenciar Pausa) -->

<ng-template #gerenciarPausa let-modal>
  <div class="modal-header pl-3">
    @if (pausaSelecionada == null) {
      <h3 class="modal-title" id="titulo-gerenciar-pausa"><b>Nova (Pausa)</b></h3>
    }
    @if (pausaSelecionada != null) {
      <h3 class="modal-title" id="titulo-gerenciar-pausa"><b>Alterar (Pausa)</b></h3>
    }

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="height: 360px;">
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Vendedor(a):</b></label>

        <select class="form-control form-control-sm" name="vendedor" #vendedor (change)="selecionarVendedor(vendedor.value)">
          @for (opcao of vendedores; track opcao) {
            <option [value]="opcao.id" [selected]="vendedorSelecionado != null ? opcao.id == vendedorSelecionado.id : null">{{ opcao.fullname }}</option>
          }
        </select>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-sm-10">
        <label><b>Motivo:</b></label>

        <select class="form-control form-control-sm" name="motivoPausa" #motivoPausa (change)="selecionarMotivoPausa(motivoPausa.value)">
          @for (opcao of motivosPausa; track opcao) {
            <option [value]="opcao.id" [selected]="motivoPausaSelecionado != null ? opcao.id == motivoPausaSelecionado.id : null">{{ opcao.nome }}</option>
          }
        </select>

        @if (motivoPausaInvalido) {
          <div class="erro pt-1">Motivo inválido!</div>
        }
      </div>

      <div class="form-group col-sm-2">
        <label><b>Tempo:</b></label>

        <ngb-timepicker name="motivoPausaTempo" [spinners]="false" [(ngModel)]="motivoPausaTempo"></ngb-timepicker>

        @if (motivoPausaTempoInvalido) {
          <div class="erro pt-1">Tempo inválido!</div>
        }
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-sm-2">
        <label><b>Hr. Inicial:</b></label>

        <ngb-timepicker name="horaInicial" [spinners]="false" [(ngModel)]="horaInicial"></ngb-timepicker>

        @if (horaInicialInvalida) {
          <div class="erro pt-1">Hr. Inicial inválida!</div>
        }
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Salvar')">Salvar</button>
  </div>
</ng-template>

@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          <div class="titulo_texto">Call Center - Gerenciar Discador</div>
        </div>
        <div class="d-flex flex-wrap flex-grow-1 justify-content-end">
          <button class="btn btn-secondary btn_titulo" type="button" (click)="modalGerenciarPausa(gerenciarPausa, null)">Nova Pausa</button>
        </div>
      </div>
    </div>
    <!-- Dados -->
    <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
      <div class="table-responsive">
        <table class="table table-sm">
          <thead>
            <tr>
              <th></th>
              <th class="tabela_borda"></th>
              <th class="tabela_borda">Vendedor(a)</th>
            </tr>
          </thead>
          <tbody>
            @for (vendedor of vendedores; track vendedor; let i = $index) {
              <tr>
                <td class="text-center tabela_acao">
                  <i class="fa  btn_tabela_acao" [ngClass]="i == vendedorExpandido ? 'fa-arrow-up' : 'fa-arrow-down'" placement="right" ngbTooltip="Expandir/Recolher" (click)="expandir(i, vendedor.id)"></i>
                </td>
                <td class="text-center tabela_acao tabela_borda">
                  @if (vendedor.call_center_discador_automatico) {
                    <i class="fa fa-pause btn_tabela_acao"  placement="right" ngbTooltip="Discador Manual" (click)="alterarCallCenterDiscadorAutomatico(vendedor.id, false)"></i>
                  }
                  @if (!vendedor.call_center_discador_automatico) {
                    <i class="fa fa-play btn_tabela_acao"  placement="right" ngbTooltip="Discador Automático" (click)="alterarCallCenterDiscadorAutomatico(vendedor.id, true)"></i>
                  }
                </td>
                <td class="tabela_borda">{{ vendedor.fullname }}</td>
              </tr>
              @if (i == vendedorExpandido) {
                <tr [@esvanecerDesvanecer]="'in'">
                  <td class="p-3" colspan="3">
                    <table class="table table-sm table-hover">
                      <thead>
                        <tr>
                          <th></th>
                          <th class="tabela_borda"></th>
                          <th class="tabela_borda">Motivo</th>
                          <th class="text-center tabela_borda">Tempo</th>
                          <th class="text-center tabela_borda">Hr. Inicial</th>
                          <th class="text-center tabela_borda">Hr. Final</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (pausa of pausas; track pausa) {
                          <tr>
                            <td class="text-center tabela_acao">
                              <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="modalGerenciarPausa(gerenciarPausa, pausa.id)"></i>
                            </td>
                            <td class="text-center tabela_acao tabela_borda">
                              <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Excluir" (click)="deletarPausa(pausa.id)"></i>
                            </td>
                            <td class="tabela_borda">{{ pausa.nome }}</td>
                            <td class="text-center tabela_borda">{{ pausa.tempo_pausa }}</td>
                            <td class="text-center tabela_borda">{{ pausa.hr_inicial_pausa }}</td>
                            <td class="text-center tabela_borda">{{ pausa.hr_final_pausa }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
